import { render } from "./followuplist.vue?vue&type=template&id=4c21c913"
import script from "./followuplist.vue?vue&type=script&lang=js"
export * from "./followuplist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__